"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_QUESTION = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.ADMIN_QUESTION = (0, client_1.gql) `
  ${fragments_1.QUESTION_COMMENT_FIELDS}
  ${fragments_1.PICTURE_FIELDS}
  query QuestionData($id: Int!) {
    admin {
      question(id: $id) {
        ... on QuestionEMQ {
          cases {
            id
            questionId
            case
            explanation
            label
          }
        }
        id
        public
        conceptId
        difficulty
        question
        learningPoint
        explanation
        createdAt
        updatedAt
        typeId
        likes
        dislikes
        totalVotes
        presentations {
          id
          name
          topicId
          topic {
            id
            name
          }
        }
        conditions {
          id
          name
          topicId
          topic {
            id
            name
          }
        }
        entitlements {
          id
          entitlementId
          questionId
        }
        pictures {
          ...PictureFields
        }
        comments {
          ...QuestionCommentFields
        }
        revisions {
          id
          questionId
          createdAt
          updatedAt
          conceptId
          difficulty
          typeId
          question
          explanation
          learningPoint
          answer
          choices {
            id
            name
            explanation
            label
            answer
            votes
            updatedAt
          }
          cases {
            id
            questionId
            case
            explanation
            label
            updatedAt
          }
        }
        choices {
          id
          name
          explanation
          label
          answer
          votes
          updatedAt
        }
        topic {
          id
          name
        }
        concept {
          id
          name
          topicId
        }
      }
    }
  }
`;
